// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__d-LHx","primary":"Button_primary__4nIwT"};